import { takeLatest, all, fork, put, call } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* fetchVideo({ id, callbacks }) {
  try {
    const { data } = yield call(api.fetchVideo, id);
    yield put(Actions.fetchVideoSuccess(data));
    if (typeof callbacks?.success === 'function') {
      yield call(callbacks.success, data);
    }
  } catch (error) {
    yield put(Actions.fetchVideoFail(error));
    if (typeof callbacks?.failure === 'function') {
      yield call(callbacks.failure);
    }
  }
}

function* watchFetchVideo() {
  yield takeLatest(Actions.FETCH_VIDEO_REQUEST, fetchVideo);
}

export default function* info() {
  yield all([fork(watchFetchVideo)]);
}
